import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './header';
import MainContent from './maincontent';
import BuySell from './buySell/buysell';
import Forum from './forums/forum';
import CreateAd from './buySell/createAd';
import MyListings from './buySell/mylistings';
import EditAd from './buySell/editad';
import ViewAd from './buySell/viewad';
import ClubChat from './forums/clubchat';
import ProfilePage from './profile/myprofile';
import Messages from './messaging/messaging';
import ViewProfile from './profile/viewOtherProfile';
import 'antd/dist/reset.css';
import Footer from './Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<MainContent />} />
        <Route path="/buysell" element={<BuySell />} />
        <Route path="/forums" element={<Forum />} />
        <Route path="/create-ad" element={<CreateAd />} />
        <Route path="/my-listings" element={<MyListings />} />
        <Route path="/edit-ad/:id" element={<EditAd />} />
        <Route path="/view-ad/:id" element={<ViewAd />} />
        <Route path="/club-chat" element={<ClubChat />} />

        <Route path="/messages" element={<Messages />} />
        <Route path="/messages/chat/:chatId" element={<Messages />} />
        <Route path="/messages/new/:adId" element={<Messages />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/view-profile/:userId" element={<ViewProfile />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;                 